const menuCategories = [
  {
    icon: 'fa-line-chart',
    title: 'Indicadores',
    items: [
      {
        title: 'Painel',
        route: 'painel'
      }
    ]
  },
  {
    icon: 'fa-bar-chart',
    title: 'Análise',
    items: [
      {
        title: 'Painel',
        route: 'painelanalise'
      },
      {
        title: 'Dashboard Geral',
        route: 'dashboardgeral'
      }
    ]
  }
]

export default menuCategories;
